import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-record-found',
  templateUrl: './no-record-found.component.html',
  styleUrls: ['./no-record-found.component.scss'],
})
export class NoRecordFoundComponent implements OnInit {

  @Input() image;
  @Input() icon;
  @Input() router;
  @Input() heading;
  @Input() height;
  @Input() content;
  @Input() column;
  @Input() bg_color;
  @Input() border_radius;
  @Input() border_r;

  @Input() image_div_height;
  @Input() image_div_width;
  @Input() image_height;
  @Input() image_width;
  
  constructor() { }

  ngOnInit() {}

}
